import { Component, Input } from '@angular/core';
import { ProfileData } from '../../../models/profile/profile.model';
import { MatDialog } from '@angular/material/dialog';
import { AdminMandant } from '../../../models/cloud/cloud.model';

@Component({
  selector: 'fi-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {

  @Input() profileData: ProfileData;
  @Input() adminMandant?: AdminMandant;

  constructor(
    private dialog: MatDialog,
  ) {
  }

  cleanLeadIndexSession(): void {
    if (!!sessionStorage.getItem('offset')) {
      sessionStorage.setItem('offset', '');
    }

    if (!!sessionStorage.getItem('overviewSwiperIndex')) {
      sessionStorage.setItem('overviewSwiperIndex', '0');
    }
    if (!!sessionStorage.getItem('swiperContainerLength')) {
      sessionStorage.setItem('swiperContainerLength', '');
    }
    sessionStorage.setItem('fromStartPage', 'true')
    sessionStorage.setItem('pageNumber', '0')
    sessionStorage.setItem('overviewScrollPosition', '0')
  }
}
